"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultShippingInfo = void 0;
class DefaultShippingInfo {
}
exports.DefaultShippingInfo = DefaultShippingInfo;
//# sourceMappingURL=default-shipping-info.model.js.map